<template>
  <div class="licence-uploader">
    <!-- 只读模式：显示图片 -->
    <div v-if="mode === 'view'">
      <img
        v-if="value"
        :src="value"
        class="licence-image"
        alt="资质证明"
      />
      <div v-else class="empty-tip">暂无资质证明文件</div>
    </div>

    <!-- 编辑模式：显示上传/预览 -->
    <div v-else class="edit-mode">
      <!-- 隐藏的 file input，始终存在 -->
      <input
        ref="fileInput"
        type="file"
        accept="image/*,.pdf"
        class="hidden-input"
        @change="onFileChange"
      />

      <!-- 有预览：显示图片 + 删除按钮 -->
      <div v-if="previewUrl" class="preview-wrap">
        <img :src="previewUrl" class="licence-image" alt="资质证明预览" />
        <button
          type="button"
          class="remove-btn"
          @click="clearFile"
        >×</button>
      </div>

      <!-- 无预览：显示上传区 -->
      <div v-else class="upload-area" @click="triggerSelect">
        <span class="plus-icon">+</span>
        <span class="upload-text">点击上传资质证明文件</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LicenceUploader',
  props: {
    // 图片 URL（view 模式显示；edit 模式作为初始预览）
    value: {
      type: String,
      default: ''
    },
    // 'view' | 'edit'
    mode: {
      type: String,
      default: 'view'
    }
  },
  data() {
    return {
      // 本地预览：新选的 file 或已有的 url
      previewUrl: '',
      // 新选的文件对象，父组件提交时用
      localFile: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        // 初始时把 value 作为预览
        this.previewUrl = val || ''
      }
    },
    mode: {
      immediate: true,
      handler(val) {
        // 切到 edit 时清空本地状态（防止残留）
        if (val === 'edit') {
          this.previewUrl = this.value || ''
          this.localFile = null
          this.$nextTick(() => {
            if (this.$refs.fileInput) this.$refs.fileInput.value = ''
          })
        }
      }
    }
  },
  methods: {
    triggerSelect() {
      this.$refs.fileInput && this.$refs.fileInput.click()
    },
    onFileChange(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return
      this.localFile = file
      // 用 URL.createObjectURL 生成预览（比 FileReader 更轻）
      this.previewUrl = URL.createObjectURL(file)
      // 通知父组件文件变化
      this.$emit('file-change', file)
    },
    clearFile() {
      // 释放 blob url
      if (this.previewUrl && this.previewUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.previewUrl)
      }
      this.localFile = null
      this.previewUrl = ''
      if (this.$refs.fileInput) this.$refs.fileInput.value = ''
      this.$emit('file-change', null)
      this.$emit('clear')
    }
  },
  beforeDestroy() {
    if (this.previewUrl && this.previewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.previewUrl)
    }
  }
}
</script>

<style scoped lang="scss">
.licence-uploader {
  width: 100%;
}

.empty-tip {
  color: #909399;
  font-size: 14px;
  padding: 8px 0;
}

.hidden-input {
  display: none;
}

.preview-wrap {
  position: relative;
  display: inline-block;
  max-width: 100%;
}

.licence-image {
  width: 512px;
  max-width: 100%;
  object-fit: cover;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: block;
}

.remove-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ff4d4f;
  color: #fff;
  border: none;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: #ff7875;
  }
}

.upload-area {
  width: 100%;
  height: 160px;
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  background-color: rgba(240, 244, 249, 0.5);
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #909399;

  &:hover {
    border-color: #409eff;
    background: #f0f7ff;
  }
}

.plus-icon {
  font-size: 32px;
  color: #409eff;
  line-height: 1;
}

.upload-text {
  font-size: 14px;
}
</style>
